import createReducer from 'reducers/createReducer';

import { Billing } from 'actions/actionTypes';

const INITIAL_STATE = { 
    isRecurringPayment: false,
    isInventory: 0,

    error: {
        triggered: false,
        message: ''
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [Billing.CHANGE_IS_RECURRING_PAYMENT]: (state, action) => {
        state.isRecurringPayment = action.payload;
    },

    [Billing.CHANGE_IS_INVENTORY]: (state, action) => {
        state.isInventory = state.isInventory + 1;
    },
});


export default reducer;